import React, { useContext } from 'react';

import { shopItemListFilteringEnum } from '@service/shopItemService';
import { AccountContext } from "@context/AccountProvider";
import { useTranslation } from "react-i18next";

import {
    Box,
    TextField,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    Select,
    MenuItem,
    IconButton,
    Typography
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

export default function ShopPageFiltering({
    searchText,
    onSearchChange,
    selectedFilter,
    onFilterChange,
    site,
    onSiteChange
}) {
    const { sites } = useContext(AccountContext);
    const { t } = useTranslation(["main", "shop"]);

    return (
        <Box sx={{ p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <TextField
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder={t("shop:searchPlaceholder")}
                    value={searchText || ''}
                    onChange={(e) => onSearchChange(e.target.value)}
                    InputProps={{
                        startAdornment: <SearchIcon sx={{ mr: 1 }} />,
                        endAdornment: searchText && (
                            <IconButton onClick={() => onSearchChange("")}>
                                <ClearIcon />
                            </IconButton>
                        )
                    }}
                />
            </Box>

            <Typography fontWeight="bold">{t("shop:availabilityLabel")}</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'left', flexWrap: 'wrap', gap: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        row
                        value={selectedFilter}
                        onChange={(e) => onFilterChange(e.target.value)}
                    >
                        <FormControlLabel value={shopItemListFilteringEnum.ALL} control={<Radio />} label={t("shop:filter.all")} />
                        <FormControlLabel value={shopItemListFilteringEnum.ONLY_AVAILABLE} control={<Radio />} label={t("shop:filter.available")} />
                        <FormControlLabel value={shopItemListFilteringEnum.ONLY_UNAVAILABLE} control={<Radio />} label={t("shop:filter.unavailable")} />
                    </RadioGroup>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: 120, display: "flex", flexDirection: "row", alignItems: "center", gap: 1 }}>
                    <Typography variant="text">{t("shop:availableAtSite")}</Typography>
                    <Select
                        labelId="site-label"
                        value={site}
                        onChange={(e) => onSiteChange(e.target.value)}
                        displayEmpty
                    >
                        <MenuItem value="" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                            {t("shop:doesNotMatter")}
                        </MenuItem>
                        {sites.length > 0 && sites.map((site) => (
                            <MenuItem value={site.uuid} key={"sa_fil" + site.uuid}> {site.name} </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        </Box>
    );
}
